module.exports = __webpack_public_path__ + "img/features_moneymanager_phone.deeed5b8.jpg";